<script setup lang="ts">
  import { inject } from 'vue';
  import { TundrLogo, TundrLogoVariant } from '../../TundrLogo';
  import {
    leftSectionBackgroundClass,
    leftSectionContentClass,
    mainContainerClass,
    mainContentBackgroundClass,
    logoClass,
    messageClass,
    mainContentClass,
    appVersionClass,
  } from './AuthPageLayout.css.ts';
  import Background from '@tundr/theme-assets/images/auth-background.jpg?url';

  defineProps<{
    message?: string;
  }>();

  const appVersion = inject('appVersion');
</script>

<template>
  <div :class="mainContainerClass">
    <div v-if="appVersion" :class="appVersionClass">v. {{ appVersion }}</div>
    <div
      :class="leftSectionBackgroundClass"
      :style="{ backgroundImage: `url(${Background})` }"
    >
      <div :class="leftSectionContentClass">
        <TundrLogo :variant="TundrLogoVariant.DARK" :class="logoClass" />
        <slot name="message">
          <span v-if="message" :class="messageClass">{{ message }}</span>
        </slot>
      </div>
    </div>
    <div :class="mainContentBackgroundClass">
      <slot name="content">
        <div :class="mainContentClass"><slot /></div>
      </slot>
    </div>
  </div>
</template>
